import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const UploadModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);

  useImperativeHandle(ref, () => ({
    open: async (record = {}) => {
      try {
        setCurrentRecord(record || null);
        form.setFieldsValue({
          insuranceType: record?.insuranceType || "",
          remark: record?.remark || "",
        });
        setVisible(true);
      } catch (error) {
        message.error("Failed to initialize modal data");
        console.error("Initialization error:", error);
      }
    },
  }));

  const closeModal = () => {
    setVisible(false);
    setCurrentRecord(null);
    form.resetFields();
  };

  const onFinishAdd = async (values) => {
    try {
      setLoading(true);

      const queryParams = {
        id: currentRecord?.id,
        insuranceType: values.insuranceType,
        remark: values.remark,
      };

      const response = await http.post(`${api.getInsuranceTypeUpdate}`, queryParams);
      if (response.code === "1") {
        message.success("Update successfully.");
        closeModal();
        onSuccess?.();
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      message.error("Request Error");
    } finally {
      setLoading(false);
    }
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <>
      <Modal
        title={
          <Flex justify="flex-start" align="flex-start" className="model_title">
            <EditOutlined className="model_title_mr10" />
            <Typography.Title level={4} className="mg">
              UPLOAD INSURANCE TYPE
            </Typography.Title>
          </Flex>
        }
        width="50%"
        open={visible}
        onCancel={closeModal}
        maskClosable={false} 
        footer={
                 <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button key="back" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>}
        centered
      >
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div className="model_content">
              <Form
                {...layout}
                name="AddForm"
                onFinish={onFinishAdd}
                form={form}
                labelCol={{
                  style: {
                    width: "150px",
                  },
                }}
                wrapperCol={{
                  style: {
                    flex: 1,
                  },
                }}
              >
                <Form.Item
                  name="insuranceType"
                  label="Insurance Type"
                  rules={[{ required: true, message: "Please enter Insurance Type" }]}
                >
                  <Input placeholder="Please enter Insurance Type" allowClear />
                </Form.Item>

                <Form.Item name="remark" label="Remark">
                  <Input placeholder="Please enter Remark" allowClear />
                </Form.Item>
              </Form>
            </div>
          </div>
        </Flex>
      </Modal>
    </>
  );
});

export default UploadModal;
